var map = {
	"./Andrea Holz-Dahrenstaedt.jpg": "f8af",
	"./Christa Musger.jpg": "44ea",
	"./Christoph Rabl.jpg": "c412",
	"./Gerhard Hofbauer.jpg": "61f4",
	"./Romy Seidl.jpg": "c7df",
	"./Wolfgang Schramml.jpg": "21d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8b2e";